import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_w-100" }
const _hoisted_2 = { class: "gfu-project-summary-stats__content" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h4 _tc--inherit _mt-3",
  "data-qa": "project-summary-stats:BackersCount"
}
const _hoisted_4 = {
  class: "gfu-hd gfu-hd--d1 _tc--inherit _mb-3",
  "data-qa": "project-summary-stats:FundsGathered"
}
const _hoisted_5 = {
  key: 0,
  class: "_mt-0",
  "data-qa": "project-summary-stats:PercentageOfGoal"
}
const _hoisted_6 = { "format-key": "0" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "gfu-project-summary-funded-info gfu-project-summary-funded-info--outlined",
  "data-qa": "project-summary-box:FundedBanner"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "_mt-3 _mb-1",
  "data-qa": "project-summary-box:FundedAt"
}
const _hoisted_11 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_localize = _resolveComponent("localize")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectSummaryBackerCountSubHeader, $options.totalBackersCount)), 1 /* TEXT */),
      _createElementVNode("h3", _hoisted_4, [
        _createVNode(_component_display_currency_value, {
          "display-tooltip": false,
          tag: "span"
        }, {
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.convertedFundsGathered), 1 /* TEXT */)
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.formattedFundsGathered), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      (!$props.isExternalCampaign)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.isOriginalTypeExpressCrowdfunding)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createVNode(_component_localize, {
                    resource: _ctx.Resources.ProjectHome.ProjectSummaryStatisticsPercentageOfGoalText
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", _hoisted_6, _toDisplayString($props.percentageOfGoal), 1 /* TEXT */),
                      _createVNode(_component_display_currency_value, {
                        "format-key": "1",
                        "display-tooltip": false,
                        tag: "strong"
                      }, {
                        content: _withCtx(({ displayCurrency }) => [
                          _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal / displayCurrency.relativeFactor, 'C0', displayCurrency.symbol)), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal, 'C0')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"])
                ]))
              : _createCommentVNode("v-if", true),
            ($options.hasStretchGoals)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "_mt-0",
                  innerHTML: $options.stretchGoalsText,
                  "data-qa": "project-summary-stats:StretchGoalsCount"
                }, null, 8 /* PROPS */, _hoisted_7))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($options.isFundedAtTextVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", { innerHTML: $options.goalReachedInText }, null, 8 /* PROPS */, _hoisted_9)
        ]))
      : _createCommentVNode("v-if", true),
    ($options.fundedAtDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectSummaryBoxFundedAtText, $options.fundedAtDate)), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($options.shouldShowOriginalCampaignButton)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: $options.originalCampaignUrl,
          class: "gfu-btn gfu-btn--transparent-inverse gfu-btn--soft gfu-project-summary-action",
          "data-qa": "project-summary:ViewOriginal"
        }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxOriginalCampaignButton), 9 /* TEXT, PROPS */, _hoisted_11))
      : _createCommentVNode("v-if", true),
    ($options.showFollowButton)
      ? (_openBlock(), _createBlock(_component_project_summary_follow, {
          key: 3,
          theme: "inverse",
          "button-theme": "transparentInverse",
          class: "_mt-2"
        }))
      : _createCommentVNode("v-if", true)
  ]))
}